import { Button } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import React, { useEffect } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import MakeAsyncFunction from "react-redux-promise-listener";
import { useParams } from "react-router-dom";
import {
  EDIT_ACCESSORY_ERROR,
  EDIT_ACCESSORY_REQUEST,
  EDIT_ACCESSORY_RESPONSE,
} from "../../../actions/accessories.actions";
import { appActions } from "../../../actions/app.actions";
import { promiseListener } from "../../../helpers/store";
import AccessoriesForm from "./AccessoriesForm";

export default function AccessoriesEdit() {
  let { accessoryId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.setNextPage("/renov/accessories"));
  }, [dispatch]);

  let accessory = useSelector((state) => {
    return state.accessories.all[accessoryId] || {};
  });

  let image = useSelector((state) => {
    return state.medias.all[accessory.image] || {};
  });

  let pdf = useSelector((state) => {
    return state.medias.all[accessory.pdf] || {};
  });

  return (
    <div>
      <MakeAsyncFunction
        listener={promiseListener}
        start={EDIT_ACCESSORY_REQUEST}
        resolve={EDIT_ACCESSORY_RESPONSE}
        reject={EDIT_ACCESSORY_ERROR}
      >
        {(onSubmit) => (
          <Form
            onSubmit={(form) => {
              form.price = parseFloat(form.price);
              form.ral = typeof form.ral !== 'undefined' ? parseInt(form.ral) : null;
              return onSubmit(form);
            }}
            mutators={{
              setValue: ([field, value], state, { changeValue }) => {
                changeValue(state, field, () => value);
              },
            }}
            initialValues={accessory}
            render={({ handleSubmit, submitting, form }) => (
              <form onSubmit={handleSubmit}>
                <AccessoriesForm
                  image={image.contentUrl || null}
                  pdf={pdf.contentUrl || null}
                  setValue={form.mutators.setValue}
                />

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Editer
                  </Button>
                </Box>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    </div>
  );
}
